const { useEffect } = require('react');

const internals = {};

internals.getGlobalDebug = () => {

    try {
        const { context } = require('app-context');
        const state = context.redux?.hooks?.getState?.();

        return context.selectors?.all?.getDebug?.(state) || {};
    }
    catch (err) {
        return {};
    }
};

internals.resolveDebugEnabled = ({
    debug,
    globalDebug
}) => {

    if (debug === true) {
        return true;
    }

    if (debug === false) {
        return false;
    }

    if (debug?.enabled === true || debug?.forms === true) {
        return true;
    }

    return !!globalDebug?.forms;
};

internals.getDebugName = ({
    debug,
    title
}) => {

    if (typeof debug?.name === 'string') {
        return debug.name;
    }

    return title || 'anonymous form';
};

internals.buildFieldDebugState = ({
    fields = [],
    methods
}) => fields.reduce((collector, field) => {

    if (!field?.name) {
        return collector;
    }

    collector[field.name] = {
        value: typeof methods.getValues === 'function'
            ? methods.getValues(field.name)
            : undefined,
        state: typeof methods.getFieldState === 'function'
            ? methods.getFieldState(field.name, methods.formState)
            : undefined,
        error: typeof methods.getFieldState === 'function'
            ? methods.getFieldState(field.name, methods.formState)?.error
            : undefined
    };

    return collector;
}, {});

module.exports = function useFormDebug({
    debug,
    title,
    fields,
    defaults,
    methods
}) {

    const globalDebug = internals.getGlobalDebug();
    const enabled = internals.resolveDebugEnabled({
        debug,
        globalDebug
    });
    const debugName = internals.getDebugName({
        debug,
        title
    });

    useEffect(() => {

        if (!enabled) {
            return;
        }

        // eslint-disable-next-line no-console
        console.groupCollapsed(`[useForm] ${debugName}`);
        // eslint-disable-next-line no-console
        console.log('fields', fields);
        // eslint-disable-next-line no-console
        console.log('defaults', defaults);
        // eslint-disable-next-line no-console
        console.log('values', typeof methods.getValues === 'function' ? methods.getValues() : undefined);
        // eslint-disable-next-line no-console
        console.log('formState', methods.formState);
        // eslint-disable-next-line no-console
        console.log('formState.errors', methods.formState?.errors);
        // eslint-disable-next-line no-console
        console.log('fieldStates', internals.buildFieldDebugState({
            fields,
            methods
        }));
        // eslint-disable-next-line no-console
        console.groupEnd();
    }, [
        defaults,
        debugName,
        enabled,
        fields,
        methods
    ]);

    return {
        enabled,
        name: debugName
    };
};

module.exports.internals = internals;
